import { useState, useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';

export default function OpenInAppBanner() {
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const fromEmail = params.get('ref') === 'email' || params.get('utm_source') === 'email';
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    const dismissed = sessionStorage.getItem('open-in-app-dismissed');

    if (fromEmail && !isStandalone && !dismissed) {
      setShow(true);
      setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent));
    }
  }, []);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem('open-in-app-dismissed', 'true');
  };

  if (!show) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-violet-600 to-amber-500 text-white px-4 py-3 shadow-lg"
      style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.75rem)' }}
      data-testid="open-in-app-banner"
    >
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
            <ExternalLink className="w-4 h-4" />
          </div>
          <p className="text-sm font-medium truncate">
            {isIOS
              ? 'Open ExpatsSphere from your home screen for the best experience'
              : 'Open this page in the ExpatsSphere app'}
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {!isIOS && (
            <button
              onClick={() => {
                const url = new URL(window.location.href);
                url.searchParams.delete('ref');
                url.searchParams.delete('utm_source');
                window.location.href = url.toString();
              }}
              className="bg-white text-violet-700 text-xs font-bold px-3 py-1.5 rounded-full hover:bg-white/90 transition-colors"
              data-testid="open-in-app-btn"
            >
              Open App
            </button>
          )}
          <button
            onClick={dismiss}
            className="text-white/80 hover:text-white p-1"
            data-testid="dismiss-app-banner"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
